import ActionType from "../../../ActionType";

const currentOrganization = organization => ({
	type: ActionType.CURRENT_ORGANIZATION,
    organization,
});
export default currentOrganization